module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {
	'use strict';
	var _ = {
		getApi: function (alias, apiConf) {
			var 
				def = {method: this.getOption(['methods', alias].join('.'))},
				w = this.wom1(['#api', fox.ucfirst(alias)].join(''));

			if (apiConf === undefined) {
				apiConf = fox.clone(def);
			} else {
				apiConf = fox.merge(def, apiConf);
			}

			if (!w) {
				w = this.embedWidget(['api', fox.ucfirst(alias)].join(''), 'Api', apiConf);

				if (!w.isRun()) {
					w.run();
				}
			}

			return w;
		}
	};

	fox.registerWidget('Social_Activity', {

		getApi: function () {
			return _.getApi.apply(this, arguments);
		},

		configure: function() {
			this.registerOptions('', {
				subject: 'content'
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.data = {};

			if (this.getOption('targetDl')) {
				this.handleEvent(this.getOption('targetDl'), 'loaded', 'targetDlLoaded');
			}
			return this.callParent('init', arguments);
		},

		//instead running
		loadData: function() {
			if (fox.isEmpty(this.targetIds)) {
				fox.log('targetIds are empty. Load skipped');
				return;
			}

			var api = this.getApi('load');

			this.handleEvent(api, 'ready', '_loaded');
			api.send(this.getLoadParams(), false);
		},

		getLoadParams: function() {
			return {'ids': this.targetIds, 'subject': this.requireOption('subject')};
		},

		_loaded: function(response) {
			this.data = this.prepareData(response);
			this.render();
		},

		prepareData: function(data) {
			fox.each(data, this.prepareDataItem, this);

			return data;
		},

		prepareDataItem: function(item, targetId) {
			if (targetId) {
				item.targetId = parseInt(targetId);
			}
			return item;
		},

		rendering: function() {
			if (fox._isNewfe) {
				this.fragment = this.getTemplater().setData([fox.mixin(this.data[this.currentTargetId] || {}, this.getTemplateOptions() || {})]).compile();
			} else {
				this.fragment = fox.Zen(this.options.template, [this.data[this.currentTargetId] || {}]);
			}
			this.currentTargetId = null;
		},

		embedding: function() {
			this.element = [];
			var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);
			fox.each(containers, function(container) {
				if (!!this.getOption('targetDl') && !!this.getOption('targetField')) {
					var dl = this.wom1(this.getOption('targetDl'));
					fox.each(dl.getCollection(), function (obj) {
						this.currentTargetId = fox.objectGet(obj, this.getOption('targetField'));
					}, this);
				} else {
					this.currentTargetId = container.getAttribute('data-target-id');
				}
				this._render(true);
				this.embedToDom(container, this.fragment);
			}, this);
			this._rendered = false;
		},

		setTargetIds: function(ids) {
			this.targetIds = ids;
			this.dispatchEvent('targetUpdated', ids);
			this.loadData();
		},

		targetDlLoaded: function(params, dl) {
			var obj, ids = [];
			
			fox.each(dl.getCollection(), function (obj) {
				ids.push(fox.objectGet(obj, this.getOption('targetField') || 'id'));
			}, this);
			
			this.setTargetIds(ids);
		},

		prepareCollection: function() {}

	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/social/activity.js
// module id = 454
// module chunks = 4